import { esc } from '../utils/formatters';
import { meshCoverageRuntime } from '../core/mesh-coverage-runtime';

export function renderMeshCoverageCard(data) {
    const status = data.status;
    const label = status === 'mesh' ? 'Szczegółowe modele trójwymiarowe'
        : status === 'simplified' ? 'Uproszczone modele budynków' : 'Miejsce poza obszarem Polski';
    const date = data.actual_date && /^\d{4}-\d{2}-\d{2}$/.test(data.actual_date)
        ? new Intl.DateTimeFormat('pl-PL', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' }).format(new Date(data.actual_date))
        : data.actual_date;
    return '<article class="ms-card" data-mesh-coverage-card><div class="ms-card__body ms-card__content">'
        + '<div class="ms-card__heading"><h3 class="ms-card__title">Symulacja nasłonecznienia</h3>'
        + '<p class="ms-card__subtitle">' + esc(label) + '</p></div>'
        + (date ? '<p class="ms-card__meta">Aktualność danych <time datetime="' + esc(data.actual_date) + '">' + esc(date) + '</time></p>' : '')
        + '<p class="ms-card__description">' + (status === 'mesh' ? 'Geoportal opublikował model dla tego miejsca. Pobierzesz go po otwarciu symulacji.'
            : status === 'simplified' ? 'Widok korzysta z dostępnych obrysów budynków. Ich wysokości są szacowane na podstawie liczby kondygnacji.' : 'Symulacja jest dostępna dla miejsc w Polsce.') + '</p>'
        + (data.sun_simulation_url ? '<a class="ms-button ms-button--primary ms-button--block" href="' + esc(data.sun_simulation_url) + '" target="_blank" rel="noopener">Uruchom symulację nasłonecznienia</a>' : '')
        + '</div></article>';
}

export async function fetchMeshCoverage(baseUrl, latlng, signal) {
    const response = await fetch(baseUrl + 'api/widoki-3d/punkt?' + new URLSearchParams({ lat: latlng.lat, lng: latlng.lng }), { signal });
    if (!response.ok) throw new Error('Nie udało się sprawdzić pokrycia.');
    return response.json();
}

// Detail renderers replace the direct children as their asynchronous data arrives.
// Keep the point card attached without duplicating it in every entity renderer.
export function attachMeshCoverageDetails({ element, getPoint, baseUrl }) {
    let key = null;
    let result = null;
    let request = null;
    let failed = false;
    let timer = null;
    function sync() {
        const point = getPoint();
        let card = element.querySelector('[data-mesh-coverage-detail]');
        if (!meshCoverageRuntime.getDesired() || !point) {
            if (request) request.abort();
            clearTimeout(timer);
            request = null; key = null; result = null;
            if (card) card.remove();
            return;
        }
        const next = point.lat + ',' + point.lng;
        if (key !== next) {
            if (request) request.abort();
            key = next; result = null; failed = false;
            clearTimeout(timer);
            const current = new AbortController(); request = current;
            timer = setTimeout(() => {
                if (request !== current) return;
                current.abort(); failed = true; sync();
            }, 15000);
            fetchMeshCoverage(baseUrl, point, current.signal).then(data => {
                if (!current.signal.aborted) { clearTimeout(timer); result = data; sync(); }
            }).catch(() => {
                if (!current.signal.aborted) { clearTimeout(timer); failed = true; sync(); }
            });
        }
        if (!card) {
            card = document.createElement('div');
            card.setAttribute('data-mesh-coverage-detail', '');
            element.append(card);
        }
        const html = result ? renderMeshCoverageCard(result) : failed
            ? '<div class="ms-alert"><p>Nie udało się sprawdzić pokrycia. Nie oznacza to braku modeli.</p><button class="ms-button ms-button--secondary" data-mesh-coverage-retry>Spróbuj ponownie</button></div>'
            : '<p role="status">Sprawdzanie widoków trójwymiarowych…</p>';
        if (card.innerHTML !== html) card.innerHTML = html;
    }
    element.addEventListener('click', event => {
        if (event.target.closest('[data-mesh-coverage-retry]')) { key = null; sync(); }
    });
    const observer = new MutationObserver(sync);
    observer.observe(element, { childList: true });
    return sync;
}
